import { App, View } from '@gin-betting/core';
import { get } from 'lodash';

import { CONFIG_BY_SPORTS, SCORE_TYPES_TITLE_MAPPING } from 'scoreMetaConfig';
import { CustomScoreTypesParser, ScoreTitleArgs } from 'types';

const getCustomScoreTypesTitleMapping = ({
    currentMatchPart,
    score,
    isOverview,
    meta,
}: ScoreTitleArgs): CustomScoreTypesParser => {
    const isNumerable = App.ScoreTypesNumerable.includes(score.type);
    const scoreTypesTitleMapping = SCORE_TYPES_TITLE_MAPPING;

    if (!currentMatchPart?.sportId) {
        return {
            scoreTypesTitleMapping,
            isNumerable,
        };
    }

    const { sportId } = currentMatchPart;

    const config = get(CONFIG_BY_SPORTS, sportId, undefined);

    return (
        config?.setMatchPartTypes?.({
            meta,
            score,
            currentMatchPart,
            isOverview,
        }) || {
            scoreTypesTitleMapping,
            isNumerable,
        }
    );
};

const textForScoreTitle = ({
    meta,
    currentMatchPart,
    score,
    isOverview,
}: ScoreTitleArgs): string => {
    const {
        scoreTypesTitleMapping,
        isNumerable,
    } = getCustomScoreTypesTitleMapping({
        score,
        currentMatchPart,
        isOverview,
        meta,
    });

    const scoreTitleText = scoreTypesTitleMapping[score.type] ?? '-';

    if (!isNumerable) {
        return scoreTitleText;
    }

    return customScoreTitle({
        type: score.type,
        index: score.indexNumber,
        sportId: currentMatchPart?.sportId,
        text: scoreTitleText,
        meta,
        isOverview,
    });
};

const getScoreTitle = ({
    meta,
    score,
    currentMatchPart,
    isOverview,
}: ScoreTitleArgs): string => {
    if (!(score.type in SCORE_TYPES_TITLE_MAPPING)) {
        return score.type;
    }

    return textForScoreTitle({ currentMatchPart, score, isOverview, meta });
};

interface CustomScoreTitle {
    sportId: string | undefined;
    type: App.ScoreTypes;
    index: number;
    text: string;
    meta: View.Meta[];
    isOverview: boolean | undefined;
}

const customScoreTitle = ({
    index,
    text,
    sportId,
    meta,
    type,
    isOverview,
}: CustomScoreTitle): string => {
    const title = index + text;

    if (!sportId) return title;

    const config = get(CONFIG_BY_SPORTS, sportId, undefined);

    return (
        config?.titleParser?.({ index, text, meta, type, isOverview }) ?? title
    );
};

export default getScoreTitle;
